import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './AccountNavigation.css';
import RippleButton from '../Forms/RippleButton';
import { StaticRoutes } from '../../Routes';

const AccountNavigation = () => {
  const {
    logout,
    isAuthenticated,
  } = useAuth0();

  const redirectToLoginPage = () => {
    const returnToUrl = `${window.location.origin}${StaticRoutes.ROOT}`;

    sessionStorage.clear();
    localStorage.clear();
    window.history.replaceState({}, document.title, StaticRoutes.ROOT);
    window.parent.postMessage({ logout: true }, '*');

    if (isAuthenticated && logout) {
      logout({
        logoutParams: {
          returnTo: returnToUrl,
          federated: true,
        },
      });
      return;
    }

    window.location.href = returnToUrl;
  };

  return (
    <div className="account-nav">
      <RippleButton
        onClick={redirectToLoginPage}
        className="logout primary"
        context="ACCOUNT_NAVIGATION_LOGOUT_CLICK"
      >
        Logout
      </RippleButton>
    </div>
  );
};

export default AccountNavigation;
